import { render } from "./BooleanTag.vue?vue&type=template&id=60baccde"
import script from "./BooleanTag.vue?vue&type=script&lang=js"
export * from "./BooleanTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__